import {FULL_ACCESS_ROLES} from "./ActivityMonitorRoles";

const MONITOR_REGION_CODES = 'monitorRegionCodes';
const RATING_ENABLED = 'ratingEnabled';
const RATING_COMPOSITE_INDICATOR_ID = 'ratingCompositeIndicatorId';
export const RATING_LEVEL = {
    ALL: 'all',
    REGION: 'region',
    CZN: 'czn',
};

let monitorRegionCodes = [];
let ratingEnabled = false;
let compositeRatingIndicatorId = null;

export function setActivityMonitorSettingsFromConfig(config) {
    const regionsSetting = config?.settings?.find(s => s?.code === MONITOR_REGION_CODES);
    monitorRegionCodes = Array.isArray(regionsSetting?.value) ? [...regionsSetting.value] : [];

    const enabledSetting = config?.settings?.find(s => s?.code === RATING_ENABLED);
    ratingEnabled = enabledSetting?.value === true;

    const compositeSetting = config?.settings?.find(s => s?.code === RATING_COMPOSITE_INDICATOR_ID);
    compositeRatingIndicatorId = compositeSetting?.value ?? null;
}

export function isRatingEnabled() {
    return ratingEnabled;
}

export function getCompositeRatingIndicatorId() {
    return compositeRatingIndicatorId;
}

export function hasMonitorRegionCodes() {
    return monitorRegionCodes.length > 0;
}

export function isMonitorRegion(code) {
    return Boolean(code) && monitorRegionCodes.includes(code);
}

export function filterMonitorRegions(regions) {
    if (!hasMonitorRegionCodes()) return [];
    return regions?.filter(r => isMonitorRegion(r.code)) ?? [];
}

export function isUserMonitorRegion(user) {
    return isMonitorRegion(user?.region?.code);
}

export function canUserAccessConfig(user, config) {
    if (FULL_ACCESS_ROLES.includes(user?.role)) return true;
    const setting = config?.settings?.find(s => s?.code === MONITOR_REGION_CODES);
    const codes = Array.isArray(setting?.value) ? setting.value : [];
    const regionCode = user?.region?.code;
    return Boolean(regionCode) && codes.includes(regionCode);
}

export function getRatingLevel(indicator) {
    const level = indicator?.rating?.level;
    if (level === RATING_LEVEL.REGION || level === RATING_LEVEL.CZN || level === RATING_LEVEL.ALL) {
        return level;
    }
    return RATING_LEVEL.ALL;
}

export function hasRegionRating(indicator) {
    const level = getRatingLevel(indicator);
    return level === RATING_LEVEL.ALL || level === RATING_LEVEL.REGION;
}

export function hasCznRating(indicator) {
    const level = getRatingLevel(indicator);
    return level === RATING_LEVEL.ALL || level === RATING_LEVEL.CZN;
}
